/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.


/*
 * EXPORTS
 */
export default gql`
mutation MyMutation($contentTranslationIds: [ID]!) {
  ContentTranslationDeleteMany(contentTranslationIds: $contentTranslationIds) {
    message
    status
  }
}
`

